import React, {useEffect} from 'react'
import './App.css';
import Login from './components/Login'
import SignUp from './components/SignUp'
import PrivacyPolicy from './components/PrivacyPolicy'
import Terms from './components/Terms'
import {Route, Redirect, Switch} from "react-router-dom";
import Menu from './components/Menu'
import Explore from './components/Explore'
import ViewSet from './components/ViewSet'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import Plans from './components/Plans'
import LandingPage from './components/LandingPage'
const UnAuth = () => {
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        if(location.pathname === '/find' || location.pathname === '/profile' || 
        location.pathname.indexOf('/space') > -1 || location.pathname === '/videochat' || location.pathname.indexOf('/room') > -1) {
            history.push({
                pathname: '/sign-up',
            });  
         }
            
      }, [location.pathname, history])
      return (
        <div>
          <header className="App-header">
              <Switch>
            <Redirect from="/profile" to="/" />
            <Route render={() => (
                <>
                <Menu />
                <LandingPage />
                </>
            )} exact path="/"/>
            <Route component={Login} exact path="/login"/>
            <Route component={SignUp} exact path="/sign-up"/>
            <Route component={Plans} exact path="/plans"/>
            <Route component={PrivacyPolicy} exact path="/privacypolicy"/>
            <Route component={Terms} exact path="/terms"/>
            <Route render={() => (
                <>
                <Menu />
                <Explore />
                </>
            )} exact path="/explore"/>
            <Route render={(props) => (
                <>
                <Menu />
                <ViewSet {...props}/>
                </>
            )} exact path="/:viewSet"/>

            </Switch>
          </header>
        </div>
    )
}

export default UnAuth
